import { FunctionComponent, memo } from 'react';
import { useTranslation } from 'react-i18next';
import { StoryCardPollContent } from '../../../../services';
import { CardContainer } from '../CardContainer';
import { Content } from '../Content';
import { RightSideStoryCardProps } from '../RightSideStoryCard';

export const Poll: FunctionComponent<RightSideStoryCardProps> = memo(({ card }) => {
  const { t } = useTranslation();

  const { content } = card;

  const { headline, text } = content as StoryCardPollContent;

  return (
    <CardContainer card={card}>
      <Content source={t('common.vote-now')} title={headline} text={text} />
    </CardContainer>
  );
});
